import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import FormTextField from '../../../Form/FormTextField';

const EntityOccupationPage = function EntityOccupationPage({
  errors,
  data,
  formData,
}) {
  const intl = useIntl();
  const { reset } = useFormContext();

  useEffect(() => {
    if (typeof data !== 'boolean' && Object.keys(data || {}).length > 0) {
      reset({
        ...(data ?? {}),
        ...(formData ?? {}),
      });
    }
  }, [data]);
  return (
    <Grid container rowSpacing="18px" columnSpacing="16px">
      <Grid size={{ md: 4, sm: 6, xs: 12 }}>
        <FormTextField
          allUpperCase
          name="employeer"
          label={intl.messages.EMPLOYER}
          error={errors?.employeer}
        />
      </Grid>
      <Grid size={{ md: 4, sm: 6, xs: 12 }}>
        <FormTextField
          allUpperCase
          name="occupation"
          error={errors?.occupation}
        />
      </Grid>
      <Grid size={{ md: 4, sm: 6, xs: 12 }}>
        <FormTextField
          allUpperCase
          name="occupationEnvironment"
          label={intl.messages.OCCUPATION_ENVIRONMENT}
          error={errors?.occupationEnvironment}
        />
      </Grid>
      <Grid size={{ md: 4, sm: 6, xs: 12 }}>
        <FormTextField
          allUpperCase
          name="workingContractType"
          label={intl.messages.WORKING_CONTRACT_TYPE}
          error={errors?.workingContractType}
        />
      </Grid>
      <Grid size={{ md: 4, sm: 6, xs: 12 }}>
        <FormTextField
          name="income"
          error={errors?.income}
          validateCallback={(value) =>
            !isNaN(value) || intl.messages.NOLETTERS_VALIDATION
          }
        />
      </Grid>
    </Grid>
  );
};

export default EntityOccupationPage;
